module.exports = __webpack_public_path__ + "img/课程培训-banner_02.9428ef0d.png";